export const isHTMLElement = (e: any): e is HTMLElement => {
    return Boolean(e?.focus);
};
